// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_fl-0";